import styled from "styled-components";

export const KeepWatchingMobileSlidesLoadingSkeletonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  overflow: hidden;
  max-width: calc(100vw - 2rem);

  > div {
    min-width: 300px;
  }
`;
